import { OrganisationProfile } from "../../models/organisation-profile";

export class GetOrganisationProfile {
    static organisationProfile: OrganisationProfile = {
    "OrganisationDetails": {
      "OrganisationId": "582914",
      "OrganisationName": "Southern Rail Logistics Pty Ltd",
      "OrganisationLegalTypeId": 2,
      "ACN": "148392765",
      "ABN": "63148392765",
      "Email": "info@southernrail.com.au",
      "Phone": "03 9123 4567",
      "Website": "https://www.southernrail.com.au",
      "OrgansationAddress": {
        "ContactAddressId": "774201",
        "AddressLine1": "120 Rail Corridor Drive",
        "AddressLine2": "Level 2",
        "Suburb": "Southbank",
        "StateId": "3",
        "StateCode": "VIC",
        "Postalcode": "3006"
      },
      "IsPostalAddress": true
    },
    "OrganisationContact": {
      "Telephone": "03 9123 4567",
      "Email": "contact@southernrail.com.au",
      "Website": "https://www.southernrail.com.au"
    },
    "AccountableContacts": [
      {
        "IndividualId": "901245",
        "ContactRole": "Accredited Accountable Person",
        "JobTitle": "Chief Executive Officer",
        "Name": "Melissa Grant",
        "WorkTelephone": "03 9123 4501",
        "WorkMobile": "0412 334 210",
        "Facsimile": "03 9123 4599",
        "Email": "melissa.grant@southernrail.com.au"
      },
      {
        "IndividualId": "901246",
        "ContactRole": "Accredited Key Contact",
        "JobTitle": "Head of Operations",
        "Name": "Daniel Rowe",
        "WorkTelephone": "03 9123 4502",
        "WorkMobile": "0413 778 542",
        "Facsimile": "03 9123 4599",
        "Email": "daniel.rowe@southernrail.com.au"
      },
      {
        "IndividualId": "901247",
        "ContactRole": "D&A Key Contact",
        "JobTitle": "Safety & Compliance Manager",
        "Name": "Priya Nair",
        "WorkTelephone": "03 9123 4503",
        "WorkMobile": "0422 661 904",
        "Facsimile": "03 9123 4599",
        "Email": "priya.nair@southernrail.com.au"
      },
      {
        "IndividualId": "901248",
        "ContactRole": "Finance Contact",
        "JobTitle": "Finance Manager",
        "Name": "Luke Bennett",
        "WorkTelephone": "03 9123 4504",
        "WorkMobile": "0408 552 119",
        "Facsimile": "03 9123 4599",
        "Email": "luke.bennett@southernrail.com.au"
      }
    ],
    "AdditionalContacts": [
      {
        "FullName": "Sophie Taylor",
        "Title": "Returns Coordinator",
        "OperatorRoles": "Monthly Returns, Occurrences, Report",
        "Email": "sophie.taylor@southernrail.com.au",
        "WorkPhone": "03 9123 4510",
        "WorkMobile": "0401 223 901"
      },
      {
        "FullName": "Mark Chen",
        "Title": "Systems Administrator",
        "OperatorRoles": "Organisation Administrator, Ontology",
        "Email": "mark.chen@southernrail.com.au",
        "WorkPhone": "03 9123 4511",
        "WorkMobile": "0402 334 882"
      },
      {
        "FullName": "Olivia Hart",
        "Title": "Compliance Officer",
        "OperatorRoles": "Notification of Change, Organisation Details",
        "Email": "olivia.hart@southernrail.com.au",
        "WorkPhone": "03 9123 4512",
        "WorkMobile": "0403 991 204"
      },
      {
        "FullName": "James O'Neill",
        "Title": "Safety Analyst",
        "OperatorRoles": "Occurrences, Ontology, Report",
        "Email": "james.oneill@southernrail.com.au",
        "WorkPhone": "03 9123 4513",
        "WorkMobile": "0404 118 663"
      },
      {
        "FullName": "Emma Rodriguez",
        "Title": "Data Manager",
        "OperatorRoles": "Monthly Returns, Report, Ontology",
        "Email": "emma.rodriguez@southernrail.com.au",
        "WorkPhone": "03 9123 4514",
        "WorkMobile": "0405 776 320"
      },
      {
        "FullName": "Noah Patel",
        "Title": "Change Coordinator",
        "OperatorRoles": "Notification of Change, Organisation Details, Occurrences",
        "Email": "noah.patel@southernrail.com.au",
        "WorkPhone": "03 9123 4515",
        "WorkMobile": "0406 443 210"
      },
      {
        "FullName": "Grace Wilson",
        "Title": "Reporting Officer",
        "OperatorRoles": "Report, Monthly Returns",
        "Email": "grace.wilson@southernrail.com.au",
        "WorkPhone": "03 9123 4516",
        "WorkMobile": "0407 225 908"
      },
      {
        "FullName": "Ethan Wright",
        "Title": "Ontology Coordinator",
        "OperatorRoles": "Ontology, Organisation Administrator",
        "Email": "ethan.wright@southernrail.com.au",
        "WorkPhone": "03 9123 4517",
        "WorkMobile": "0408 664 731"
      },
      {
        "FullName": "Chloe Martin",
        "Title": "Administration Officer",
        "OperatorRoles": "Organisation Details, Monthly Returns, Report",
        "Email": "chloe.martin@southernrail.com.au",
        "WorkPhone": "03 9123 4518",
        "WorkMobile": "0409 118 552"
      },
      {
        "FullName": "Jack Thompson",
        "Title": "Operations Liaison",
        "OperatorRoles": "Occurrences, Notification of Change",
        "Email": "jack.thompson@southernrail.com.au",
        "WorkPhone": "03 9123 4519",
        "WorkMobile": "0410 552 884"
      }
    ]
  }
}